/**
 * The pages of the app itself. They have no screen in the device configuration;
 * DynamicView shows them by the last segment of the route, wherever the route
 * sits (`/chatbotPage`, `/unit2/messagePage`).
 */
import { OVERVIEW_ROUTE } from '@/circuits/circuits'

export const APP_PAGES = [
  'messagePage',
  'profilePage',
  'chatbotPage',
  'filemanagerPage',
  'dpviewerPage',
  'adminPanelPage',
  'orderPage',
  'setupWizardPage',
  OVERVIEW_ROUTE,
] as const

export type AppPage = (typeof APP_PAGES)[number]

/** The app page a route leads to, undefined for a screen of the configuration. */
export function appPageOf(route: string): AppPage | undefined {
  const lastSegment = route.split('/').pop() ?? ''
  return APP_PAGES.find((page) => page === lastSegment)
}
